package team.platforma.multiplatform_material_extension.ui.drop_down

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import materialextension.multiplatform_material_extension.generated.resources.Res
import materialextension.multiplatform_material_extension.generated.resources.ic24_mel_exit_circle
import materialextension.multiplatform_material_extension.generated.resources.ic24_mel_search
import materialextension.multiplatform_material_extension.generated.resources.mel_ic_clear
import materialextension.multiplatform_material_extension.generated.resources.mel_ic_search
import org.jetbrains.compose.resources.painterResource
import team.platforma.multiplatform_material_extension.scrollbar.VerticalScrollIndicator
import team.platforma.multiplatform_material_extension.ui.core.InputField
import team.platforma.multiplatform_material_extension.ui.core.InputFieldProperties
import team.platforma.multiplatform_material_extension.ui.core.InputFieldStateListener
import team.platforma.multiplatform_material_extension.ui.core.StyledTextField
import team.platforma.multiplatform_material_extension.ui.core.field_utils.endIcon
import team.platforma.multiplatform_material_extension.ui.core.global_style.area.supportArea
import team.platforma.multiplatform_material_extension.ui.core.global_style.setFiledTextFieldDefaults
import team.platforma.multiplatform_material_extension.ui.core.global_style.setOutlinedTextFieldDefaults
import team.platforma.multiplatform_material_extension.ui.core.global_style.shape.setFilledTextFieldDefaultShape
import team.platforma.multiplatform_material_extension.ui.core.global_style.shape.setOutlineTextFieldDefaultShape
import team.platforma.multiplatform_material_extension.ui.core.rememberInputFieldState
import team.platforma.multiplatform_material_extension.ui.dialog.CommonDialog
import team.platforma.multiplatform_material_extension.ui.drop_down.model.ListItem
import team.platforma.multiplatform_material_extension.util.DeferredJob
import team.platforma.multiplatform_material_extension.util.forms.FormProperties
import team.platforma.multiplatform_material_extension.util.forms.keyListener
import team.platforma.multiplatform_material_extension.util.forms.rememberForms
import team.platforma.multiplatform_material_extension.util.verticalScrollbar
import team.platforma.multiplatform_material_extension.util.verticalScrollbar2
@Deprecated("")
object SearchField : InputField {

    @Composable
    fun create(
        modifier: Modifier? = null,
        itemsList: List<ListItem>,
        parent: ListItem? = null,
        searchQuery: (String) -> Unit = {},
        initializeItem: ListItem? = null,
        onSelectItem: (ListItem) -> Unit = {},
        formProperties: FormProperties? = null,
        required: Boolean = true,
        onClear: () -> Unit = {},
        searchDialogTitle: String
    ): StyledTextField {

        val form by rememberForms()

        val mForm = formProperties ?: FormProperties(form, key = "")

        LaunchedEffect(mForm.key) {
            mForm.form.initValue(mForm.key, initializeItem.toString())
            mForm.form.changeValue(mForm.key, initializeItem.toString())
        }

        return builder(
            SearchFieldImpl(
                dropItemsList = itemsList,
                parent = parent,
                searchQuery = { query ->
                    searchQuery(query)
                },
                initializeItem = initializeItem,
                selectItem = { item ->
                    onSelectItem(item)
                },
                areaModifier = modifier,
                form = mForm,
                required = required,
                clear = {
                    onClear()
                },
                searchDialogTitle = searchDialogTitle
            )
        )
    }

    override fun builder(textFieldImpl: StyledTextField): StyledTextField = textFieldImpl

}

@Composable
private fun SearchFieldImpl(
    areaModifier: Modifier?,
    dropItemsList: List<ListItem>,
    parent: ListItem?,
    searchQuery: (String) -> Unit,
    initializeItem: ListItem?,
    selectItem: (ListItem) -> Unit,
    form: FormProperties,
    required: Boolean,
    clear: () -> Unit,
    searchDialogTitle: String
): StyledTextField {

    val inputFieldState = rememberInputFieldState()

    val focusRequester = remember { FocusRequester() }
    val index = remember { form.form.registerFocus(focusRequester) }

    var query by remember { mutableStateOf("") }
    var showSearch by remember { mutableStateOf(false) }

    var allItems by remember { mutableStateOf(setOf<ListItem>()) }
    var filteredList by remember { mutableStateOf(listOf<ListItem>()) }
    var mPatent by remember { mutableStateOf<ListItem?>(null) }
    var loading by remember { mutableStateOf(false) }

    var selectedItem by remember { mutableStateOf<ListItem?>(null) }

    val coroutineScope = rememberCoroutineScope()

    val delay = remember { DeferredJob(coroutineScope) }

    LaunchedEffect(initializeItem) {

        selectedItem = initializeItem

        form.form.changeValue(form.key, initializeItem.toString())

        if (required) {
            form.form.setValidateState(form.key, initializeItem != null)
        } else {
            form.form.setValidateState(form.key, true)
        }

    }

    var showClearIcon by remember { mutableStateOf(false) }

    if (!required) {
        LaunchedEffect(selectedItem) {
            showClearIcon = selectedItem != null
        }
    }


    DisposableEffect(inputFieldState) {
        val listener = object : InputFieldStateListener {

            override fun onEndIconClick() {
                if (showClearIcon) {
                    clear()
                    selectedItem = null
                } else {
                    query = ""
                    showSearch = !showSearch
                }
            }

            override fun onAutocompleteItemSet(item: ListItem) {
                selectedItem = item
                showSearch = false
                selectItem(item)
                form.form.changeValue(form.key, item.toString())
                form.form.setValidateState(form.key, true)
            }

        }

        inputFieldState.addListener(listener)

        onDispose {
            inputFieldState.removeListener(listener)
        }
    }

    LaunchedEffect(parent) {
        if (mPatent == null) {
            if (parent != null) {
                mPatent = parent
            }
        } else {
            if (mPatent != parent) {
                mPatent = parent
                selectedItem = null
            }
        }

        form.form.changeValue(form.key, selectedItem.toString())

        if (required) {
            form.form.setValidateState(form.key, selectedItem != null)
        } else {
            form.form.setValidateState(form.key, true)
        }

        if (mPatent != null) {
            filteredList = allItems.filter { item -> item.title.contains(query, ignoreCase = true) }
                .filter { it.parent?.id == mPatent!!.id }
        } else {
            filteredList = allItems.filter { item -> item.title.contains(query, ignoreCase = true) }
        }
    }

    LaunchedEffect(query) {
        loading = false
        if (mPatent != null) {
            filteredList = allItems.filter { item -> item.title.contains(query, ignoreCase = true) }
                .filter { it.parent?.id == mPatent!!.id }
        } else {
            filteredList = allItems.filter { item -> item.title.contains(query, ignoreCase = true) }
        }

    }


    LaunchedEffect(dropItemsList) {
        loading = false
        allItems += dropItemsList.toSet()
        if (mPatent != null) {
            filteredList = allItems.filter { item -> item.title.contains(query, ignoreCase = true) }
                .filter { it.parent?.id == mPatent!!.id }
        } else {
            filteredList = allItems.filter { item -> item.title.contains(query, ignoreCase = true) }
        }
    }



    if (showSearch) {
        CommonDialog(
            onDismiss = {
                showSearch = false
            },
            title = {},
            customStyle = null,
            properties = DialogProperties(
                usePlatformDefaultWidth = false
            )
        ) {
            val dialogFocusRequester = remember { FocusRequester() }

            LaunchedEffect(Unit) {
                dialogFocusRequester.requestFocus()
            }

            val lazyListState = rememberLazyListState()

            OutlinedTextField(
                value = query,
                onValueChange = {
                    query = it
                    delay.result(1000, query) { result ->
                        loading = true
                        searchQuery(result.toString())
                        coroutineScope.launch {
                            delay(3000)
                            loading = false
                        }
                    }
                },
                modifier = Modifier
                    .fillMaxWidth().padding(start = 8.dp, end = 8.dp, top = 8.dp)
                    .focusRequester(dialogFocusRequester)
                    .keyListener(Key.Tab) {}
                ,
                leadingIcon = {
                    Box {
                        Icon(
                            modifier = Modifier.size(40.dp),
                            painter = painterResource(Res.drawable.mel_ic_search),
                            contentDescription = null
                        )

                        if (loading) {
                            CircularProgressIndicator(
                                modifier = Modifier.size(40.dp),
                            )
                        }
                    }

                }
            )
            VerticalScrollIndicator(
                state = lazyListState
            ) {
                LazyColumn(
                    modifier = Modifier.fillMaxWidth()
//                        .verticalScrollbar(lazyListState)
                    ,
                    state = lazyListState,
                    contentPadding = PaddingValues(vertical = 8.dp)
                ) {

                    if (filteredList.isNotEmpty()) {
                        itemsIndexed(filteredList) { index, item ->
                            Box(
                                modifier = Modifier.fillParentMaxWidth()
                                    .heightIn(min = 48.dp)
                                    .clickable {
                                        inputFieldState.setAutocompleteItem(item)
                                    },
                                contentAlignment = Alignment.Center

                            ) {
                                Column(
                                    modifier = Modifier.fillParentMaxWidth()
                                        .padding(horizontal = 16.dp, vertical = 4.dp)

                                ) {
                                    if (mPatent == null) {
                                        item.parent?.let { parent ->
                                            Text(
                                                text = parent.title,
                                                style = MaterialTheme.typography.bodySmall
                                            )
                                        }
                                    }
                                    Text(text = buildAnnotatedString {
                                        val queryLower = query.lowercase()
                                        val itemTitleLower = item.title.lowercase()
                                        val startIndex = itemTitleLower.indexOf(queryLower)

                                        if (startIndex != -1) {
                                            append(item.title.substring(0, startIndex))
                                            withStyle(style = SpanStyle(fontWeight = FontWeight.Bold)) {
                                                append(
                                                    item.title.substring(
                                                        startIndex,
                                                        startIndex + query.length
                                                    )
                                                )
                                            }
                                            append(item.title.substring(startIndex + query.length))
                                        } else {
                                            append(item.title)
                                        }
                                    })
                                }

                            }

                            if (index < filteredList.lastIndex) {
                                HorizontalDivider(
                                    modifier = Modifier.padding(horizontal = 16.dp),
                                    color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.12f)
                                )
                            }

                        }
                    } else {
                        item {
                            Box(
                                modifier = Modifier.fillMaxWidth()
                                    .padding(horizontal = 16.dp),
                                contentAlignment = Alignment.Center
                            ) {
                                Text(
                                    text = "Нет совпадений"
                                )
                            }

                        }

                    }

                }
            }

        }
    }



    return object : StyledTextField {
        @Composable
        override fun Outline(properties: InputFieldProperties?) {
            val mProperties = properties ?: InputFieldProperties()
            Column(
                modifier = (areaModifier ?: Modifier).width(IntrinsicSize.Min)
                    .heightIn(min = supportArea())
            ) {
                OutlinedTextField(
                    value = selectedItem?.title ?: "",
                    onValueChange = {},
                    readOnly = true,
                    trailingIcon = {
                        endIcon(
                            if (showClearIcon) Res.drawable.ic24_mel_exit_circle else Res.drawable.ic24_mel_search,
                            inputFieldState
                        )
                    },
                    label = mProperties.label,
                    modifier = (mProperties.modifier ?: Modifier)
                        .onFocusChanged { focusState ->
                        showSearch = focusState.isFocused
                    }.keyListener(Key.Tab) {
                            form.form.moveToNextFocus(index)
                        }.focusRequester(focusRequester)
                    ,
                    colors = properties?.colors ?: setOutlinedTextFieldDefaults(),
                    shape = properties?.shape ?: setOutlineTextFieldDefaultShape(),
                )
                Box(
                    modifier = Modifier.heightIn(min = supportArea()).fillMaxWidth()
                ){

                }
            }

        }

        @Composable
        override fun Filled(properties: InputFieldProperties?) {
            val mProperties = properties ?: InputFieldProperties()
            Column(
                modifier = (areaModifier ?: Modifier).width(IntrinsicSize.Min)
                    .heightIn(min = supportArea())
            ) {
                OutlinedTextField(
                    value = selectedItem?.title ?: "",
                    onValueChange = {},
                    readOnly = true,
                    trailingIcon = {
                        endIcon(
                            if (showClearIcon) Res.drawable.ic24_mel_exit_circle else Res.drawable.ic24_mel_search,
                            inputFieldState
                        )
                    },
                    label = mProperties.label,
                    modifier = (mProperties.modifier ?: Modifier)
                        .onFocusChanged { focusState ->
                            showSearch = focusState.isFocused
                        }.keyListener(Key.Tab) {
                            form.form.moveToNextFocus(index)
                        }.focusRequester(focusRequester),
                    colors = properties?.colors ?: setFiledTextFieldDefaults(),
                    shape = properties?.shape ?: setFilledTextFieldDefaultShape(),
                )
                Box(
                    modifier = Modifier.heightIn(min = supportArea()).fillMaxWidth()
                ){

                }
            }

        }

    }
}